export default "__VITE_ASSET__Cjio8gzm__"